module.exports = __webpack_public_path__ + "img/20190729161052QQ截图20190729005951.1ac48346.png";